export const PLATFORMS = {
  spotify: 'https://open.spotify.com/embed/track/04zRrKPZxAo4SIZho4bIcG?utm_source=generator&theme=0',
  appleMusic: 'https://embed.music.apple.com/us/album/miasma/1826760227?i=1826760229&itscg=30200&itsct=music_box_player&ls=1&app=music&mttnsubad=1826760229&theme=auto',
  youtubeMusic: 'https://music.youtube.com/watch?v=X4sEi_wt3Wo',
  amazon: 'https://music.amazon.com/albums/B0FHH6TML6',
  deezer: 'https://www.deezer.com/album/787756971',
  instagram: 'https://instagram.com/thenumbandalone',
};
